import { httpClient } from '@/services/http/httpClient'

type CreateForumCommentParams = {
  ideaId: string
  content: string
  file?: File
  commentIdToReply?: string
}

export async function createForumComment({
  ideaId,
  content,
  file,
  commentIdToReply,
}: CreateForumCommentParams): Promise<void> {
  const payload = new FormData()
  payload.append('ideaId', ideaId)
  payload.append('content', content)
  if (file) {
    payload.append('file', file)
  }
  if (commentIdToReply) {
    payload.append('parent_forum_comment_id', commentIdToReply)
  }

  await httpClient.post(`/ideas/forum`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
